import { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useCurrentOrganisationId } from "../../../../../services/local/organisationContext/OrganisationContextModel";
import { useFlightPathUser } from "../../../../../core/auth_insight";
import { ActionKanbanViewModel } from "./ActionKanban_model";
import { KanbanView } from "../../view/components/KanbanBoard/KanbanBoard";
import { PositionedSpinner } from "@flightpath/coreui/dist/ui/PositionedSpinner";
import { observer } from "mobx-react-lite";
import { IF } from "../../../../../components/hoc/If";

interface ActionKanbanViewProps {
  data: FP.Entities.IActionSummary[];
  searchText?: string;
}

export const ActionKanbanView: React.FC<ActionKanbanViewProps> = observer(({ data, searchText = "" }) => {
  const { projectId } = useParams();
  const organisationId = useCurrentOrganisationId();
  const authUser = useFlightPathUser();

  const model = useMemo(() => {
    return new ActionKanbanViewModel(organisationId, +projectId, authUser, data);
    // eslint-disable-next-line
  }, [organisationId, projectId, authUser]);

  useEffect(() => {
    model.onMount();
    return () => {
      model.onUnmount();
    };
  }, [model]);

  useEffect(() => {
    model.loadActions(data, searchText);
    // eslint-disable-next-line
  }, [data, searchText]);

  if (model.isLoading) {
    return <PositionedSpinner />;
  }

  return (
    <IF condition={model.userCanEditActions}>
      <KanbanView board={model.board} onCardDragEnd={model.moveCard} onCardDelete={model.deleteKanbanAction} />
    </IF>
  );
});
